import { AUTH_FROM_LOCAL, USER_LOGIN_URL } from '@/env-config';

const redirectToLoginPage = () => {
  const currentQuery = window.location.search;
  const queryString = AUTH_FROM_LOCAL
    ? currentQuery
      ? `${currentQuery}&isLocal=true`
      : '?isLocal=true'
    : currentQuery;
  window.location.href = `${USER_LOGIN_URL}${queryString}`;
};

const isAuthError = (status: unknown): boolean => {
  const errorStatus = typeof status !== 'number' ? (AUTH_FROM_LOCAL ? 401 : 400) : status;
  return errorStatus >= 401 && errorStatus <= 403;
};

export { redirectToLoginPage, isAuthError };
